module.exports = __webpack_public_path__ + "assets/6b497a03059a612915bf9820159325e9.png";